import React from 'react';

import { t } from '../../../../i18n';
import Icon from '../../../../components/Icon';

import s from './CommentPanel.module.scss';

// The API gives no name for an author who is gone, or who has no name. An own
// comment's author is never gone.
const Author = ({ comment: { author_name, is_own } }) => {
    if (!is_own) {
        return (
            <span className={s.Author}>
                {author_name ?? t('reportComments.formerUser')}
            </span>
        );
    }
    return (
        <span className={s.Author}>
            {author_name && `${author_name} `}
            <span className={s.You}>{t('reportComments.you')}</span>
        </span>
    );
};

// Who wrote it, and when. There are no pictures of readers, so everyone has
// the same one. A draft isn't written yet.
const Byline = ({ comment }) => (
    <div className={s.Byline}>
        <p className={s.Person}>
            <Icon name="UserProfile" className={s.Avatar} aria-hidden />
            <Author comment={comment} />
        </p>
        {comment.created_at && (
            <time className={s.Date} dateTime={comment.created_at}>
                {comment.created_date_display}{' '}
                <span>{comment.created_time_display}</span>
            </time>
        )}
    </div>
);

export default Byline;
